const PrivacyChoices = () => {
	return <>
		<p><strong>Last updated:</strong> March 18, 2026</p>

		<h2>Introduction</h2>
		<p>Paper Dodge ("we", "our", or "us") is committed to protecting your privacy. This Privacy Policy explains how we handle information when you use our mobile application Paper Dodge (the "App").</p>

		<h2>Information We Collect</h2>
		<p>Paper Dodge is designed to be played without requiring personal information. We do not collect your name, email address, or any personally identifiable information.</p>
		<p>The App may collect the following limited data:</p>
		<ul>
			<li><strong>Gameplay data:</strong> High scores and game progress stored locally on your device.</li>
			<li><strong>Leaderboard data:</strong> If you choose to participate in the leaderboard, a display name and score may be submitted to our leaderboard service.</li>
			<li><strong>Device data:</strong> Basic device information (e.g., device type, operating system version) may be collected automatically for crash reporting and performance purposes.</li>
		</ul>

		<h2>Third-Party Services</h2>
		<p>The App may use third-party services that collect information used to identify you. These may include:</p>
		<ul>
			<li>Apple Game Center (leaderboard functionality)</li>
			<li>Crash reporting tools</li>
		</ul>
		<p>We encourage you to review the privacy policies of any third-party services used within the App.</p>

		<h2>Children's Privacy</h2>
		<p>Paper Dodge does not knowingly collect personal information from children under the age of 13. If you are a parent or guardian and believe your child has provided us with personal data, please contact us so we can delete it.</p>

		<h2>Data Retention</h2>
		<p>Locally stored data (scores, preferences) remains on your device until you delete the App. Leaderboard data may be retained on our servers as long as the service is active.</p>

		<h2>Security</h2>
		<p>We take reasonable measures to protect your information. However, no method of transmission over the internet is 100% secure.</p>

		<h2>Changes to This Policy</h2>
		<p>We may update this Privacy Policy from time to time. We will notify you of any changes by updating the "Last updated" date at the top of this page.</p>

		<h2>Contact Us</h2>
		<p>If you have any questions about this Privacy Policy, please contact us at: <a href="mailto:hello@wearetla.com" className="hyperlink">hello@wearetla.com</a></p>
	</>
}

export default PrivacyChoices